import { Box, ListItemButton, Stack, Typography } from '@mui/material';
import { StatusChip } from '../../components/StatusChip';
import { KindIcon } from './KindIcon';
import type { Approval } from './sample';

type Props = { a: Approval; selected: boolean; onSelect: (id: string) => void };

/** One line of the list on the left of Approvals: what it is, who it is for, and whether it is urgent */
export function ApprovalListItem({ a, selected, onSelect }: Props) {
  const urgent = a.status === 'pending' && a.urgency === 'High';
  return (
    <ListItemButton
      id={`row-${a.id}`}
      selected={selected}
      onClick={() => onSelect(a.id)}
      sx={{
        alignItems: 'flex-start',
        gap: 1.5,
        py: 1.25,
        borderLeft: 4,
        borderColor: urgent ? 'error.main' : 'transparent',
      }}
    >
      <KindIcon kind={a.kind} size={36} />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" sx={{ justifyContent: 'space-between', gap: 1, alignItems: 'baseline' }}>
          <Typography sx={{ color: 'primary.main', fontWeight: 800 }}>{a.srb}</Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {a.created}
          </Typography>
        </Stack>
        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
          {a.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {a.to ?? a.subtitle}
        </Typography>
        {urgent && (
          <Box sx={{ mt: 0.5 }}>
            <StatusChip label="Urgent" tone="error" />
          </Box>
        )}
      </Box>
    </ListItemButton>
  );
}
